import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

export interface FAQItem {
  q: string
  a: string
}

interface FAQProps {
  items: FAQItem[]
  title?: string
}

/**
 * Acordeón de preguntas frecuentes. Accesible (usa <details>/<summary>
 * semánticamente, gestionado con estado para animación).
 */
export function FAQ({ items, title = 'Preguntas frecuentes' }: FAQProps) {
  const [openIdx, setOpenIdx] = useState<number | null>(0)

  return (
    <section className="marketing-faq">
      <h2 className="marketing-faq-title">{title}</h2>
      <div className="marketing-faq-list">
        {items.map((item, idx) => {
          const isOpen = openIdx === idx
          return (
            <details
              key={idx}
              className={`marketing-faq-item${isOpen ? ' marketing-faq-item--open' : ''}`}
              open={isOpen}
              onClick={(e) => {
                e.preventDefault()
                setOpenIdx(isOpen ? null : idx)
              }}
            >
              <summary className="marketing-faq-question">
                <span>{item.q}</span>
                <ChevronDown
                  size={18}
                  className="marketing-faq-chevron"
                  aria-hidden="true"
                />
              </summary>
              <p className="marketing-faq-answer">{item.a}</p>
            </details>
          )
        })}
      </div>
    </section>
  )
}
